import moment from 'moment-timezone';
import crypto from 'crypto';
import Vue from 'vue';
import { create, all } from 'mathjs';

const math = create(all, {});

let ref          = {
  frontend:         '',
  api_root:         '',
  admin_root:       '',
  mqtt_root:        '',
  socket_entry:     '',
  captcha:          false,
  captcha_key:      '',
  captcha_action:   '',
  register_subject: ''
};

const timezone     = 'Asia/Taipei';
const iiv          = '24aiVAPIMqtt<3e!';//iiv and ikey have to be the same size
const ikey         = iiv.substr(0,8);
const ffiv  = 'N6jl*Ahd1sU4kM*g';
const ffkey = 'J8jiou*oi^09Fd!9';

//loading the setting based on the location.origin
const _assign_settings = function(){
    // console.info('location.origin:', location.origin);
    let origin = location.origin;
    let map    = {
        'http://localhost:8080': {
            frontend:         'http://localhost:8080/#/dashboard/showdevice',
            frontend_entry:   'http://localhost:8080',
            api_root:         'http://localhost:8083/api',
            admin_root:       'http://localhost:8083/admin',
            mqtt_root:        'http://localhost:8083/mqtt',
            socket_entry:     'http://localhost:8083',
            captcha:          true,
            captcha_key:      '6Lc4K74qAAAAAONdWv5DUaH5ihpJgGDFEqR6b97D',
            register_subject: '註冊驗證碼',
            footer:           { text: 'localhost', email: 'eyo.lin@innoknight.com' }
        },
        'https://smart-lamp.innoknight.com':{
            frontend:         'https://smart-lamp.innoknight.com/#/dashboard/showdevice',
            frontend_entry:   'https://smart-lamp.innoknight.com',
            api_root:         'https://smart-lamp.innoknight.com/backend/api',
            admin_root:       'https://smart-lamp.innoknight.com/backend/admin',
            mqtt_root:        'https://smart-lamp.innoknight.com/backend/mqtt',
            socket_entry:     'https://smart-lamp.innoknight.com',
            captcha:          true,
            captcha_key:      '6Lc4K74qAAAAAONdWv5DUaH5ihpJgGDFEqR6b97D',
            register_subject: '註冊驗證碼',
            footer:           { text: '創玖科技股份有限公司', href: 'https://www.innoknight.com/' },
            styles:           { background: 'black url(/img/innoknight/login.bg.jpg) no-repeat top center' }
        },
    };

    let setting = map[origin] || null;

    // console.info('origin:', origin, ', setting:', setting);

    if(setting !== null){
        Object.keys(setting).map(function(key){
            ref[key] = setting[key];
        });
    } else {
        throw 'Invalid domain';
    }
};//eo _assign_settings
_assign_settings();

// console.info('ref:', ref);

const encrypt = function (data, key, iv) {

    iv  = iv || iiv;
    key = key || ikey + moment().tz(timezone).format('YYYYMMDD');

    // console.info('key:', key);

    let cipher   = crypto.createCipheriv('aes-128-cbc', key, iv);
    let encoding = 'binary';
    let result   = cipher.update(data, "utf8", encoding);
    
    result += cipher.final(encoding);

    return new Buffer(result, encoding).toString('base64');
};
 
const decrypt = function (crypted, key, iv) {

    iv  = iv || iiv;
    key = key || ikey + moment().tz(timezone).format('YYYYMMDD');

    crypted = new Buffer(crypted, 'base64').toString('binary');

    let decipher = crypto.createDecipheriv('aes-128-cbc', key, iv);
    let decoded  = decipher.update(crypted, 'binary', 'utf8');

    decoded += decipher.final('utf8');
    return decoded;
};

const mqtt_msg_parser = function(raw){
	let result = {};
    
    // console.info('raw:', raw);

	if(raw.indexOf('&') === -1){
		return null;
	}

	let ary1  = raw.split('&');
	let key   = '';
	let value = '';

	ary1.forEach((set) => {
		let eps = set.indexOf('=');
		key     = set.substr(0, eps);
		value   = set.substr(eps + 1);
        
    // console.info('key:', key, ', value:', value, ', pvalue:', parseInt(value));
        if(key === "deviceid" || key === "idtag") {
            result[key] = value;
        } else {
            result[key] = math.round(parseFloat(value), 2);
        }
	});	

	return  result;
};

const error = {
	INVALID_USER: 'INVALID_USER'
};

const cutoff_threshold = 60;//cut off the power if the value1 is lower than this value

export default {
	site_title: 'MQTT',
    locale: 'zhTW',
    timezone,
    author: 'Aitch Chung',
    debug: false,
    session: {
        secret: 'HstsMqtt231AVBKKs002!',
        name: 'MqttSession',
        resave: true,
        saveUninitialized: true,
        ephemeral: false,
        rolling: true
    },
    frontend: ref.frontend,
    api_root: ref.api_root,
    admin_root: ref.admin_root,
    mqtt_root: ref.mqtt_root,
    socket_entry: ref.socket_entry,
    frontend_entry: ref.frontend_entry,
    styles: ref.styles || null,
    overwritetitle: ref.overwritetitle || null,
    logotext: ref.logotext || null,
    page_configs: ref.page_configs || null,
    footer: ref.footer,
    captcha: ref.captcha,
    captcha_key: ref.captcha_key,
    captcha_action: ref.captcha_action,
    register_subject: ref.register_subject,
    encrypt,
    decrypt,
    error,
    ffkey,
    ffiv,
    mqtt_msg_parser,
    eventbus: new Vue()
}